import { useRouter } from 'next/router';

import { Button, Stack, Text } from '@mantine/core';

import { WorkspaceHelpers } from 'helpers/WorkspaceHelpers';

import { DismissableNotice } from 'components/dismissable-notice/DismissableNotice';
import { useCurrentTeam } from 'hooks/use-current-team';
import { useWorkspace } from 'hooks/use-workspace';
import { useWorkspaceConfig } from 'hooks/use-workspace-config';

import cx from './SwitchWorkspaceNotice.module.scss';

const SwitchWorkspaceNotice = () => {
    const { asPath } = useRouter();
    const currentTeam = useCurrentTeam();
    const currentWorkspace = useWorkspaceConfig();
    const forcedWorkspace = useWorkspace(currentTeam?.forceWorkspace);

    const forcedWorkspaceOrigin = forcedWorkspace?.key && WorkspaceHelpers.getMainDomain(forcedWorkspace.key);

    if (!currentTeam || !forcedWorkspace || !forcedWorkspaceOrigin || forcedWorkspace.key === currentWorkspace.key) {
        return null;
    }

    return (
        <DismissableNotice
            identifier={`switch-workspace-notice-${forcedWorkspace.key}`}
            refresh="daily"
            title={`Switch to the ${forcedWorkspace.name} workspace`}
            variant="default"
            radius="md"
            className={cx.notice}
        >
            <Stack gap="xs" align="flex-start">
                <Text size="sm">
                    You're currently in the general workspace.
                    <br />
                    Switch to the {forcedWorkspace.name} workspace to get access to more features.
                </Text>
                <Button component="a" href={`${forcedWorkspaceOrigin}${asPath}`} size="xs">
                    Switch
                </Button>
            </Stack>
        </DismissableNotice>
    );
};

export { SwitchWorkspaceNotice };
